import React, { useState } from "react";
import Collapse from "@mui/material/Collapse";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DscApprovalLetter from "./DscApprovalLetter";
import DscSanction from "./DscSanctionLetter";
import DscpFARApprovalLetter from "./DscpFARApprovlLetter";

const DscLetters = ({ formData, handleChange, isEmployee, viewDrawing = true, pdfType, pFARLetter=false }) => {
  const [open4, setOpen4] = useState(false);

  return (
    <div>
      <div
        className="collapse-header"
        onClick={() => setOpen4(!open4)}
        aria-controls="example-collapse-text"
        aria-expanded={open4}
        style={{
          background: "rgba(52, 73, 94, 0.94)",
          padding: "0.25rem 1.25rem",
          borderRadius: "0.25rem",
          fontWeight: "600",
          display: "flex",
          cursor: "pointer",
          color: "#817f7f",
          justifyContent: "space-between",
          alignContent: "center",
          marginTop: ".5rem",
        }}
      >
        <span style={{ color: "#fff", fontSize: 16 }}>Add Digital Signature</span>

        {open4 ? <RemoveIcon sx={{ color: "#fff" }} /> : <AddIcon sx={{ color: "#fff" }} />}
      </div>
      <Collapse in={open4}>
        <div
          id="example-collapse-text"
          style={{
            marginTop: 12,
            paddingLeft: 12,
            paddingRight: 12,
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <div style={{ marginBottom: "10px" }}>
            {pFARLetter ? <DscpFARApprovalLetter formData={formData} handleTabChange={handleChange} isEmployee={isEmployee} pdfType={pdfType}/> : <DscApprovalLetter formData={formData} handleTabChange={handleChange} isEmployee={isEmployee} pdfType={pdfType} />}
            </div>
            {viewDrawing && (
              <div>
                <DscSanction formData={formData} handleTabChange={handleChange} isEmployee={isEmployee} />
              </div>
            )}
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default DscLetters;
